import React from 'react';
import { styles } from '../Styles';
import './AccordanceReject.scss';
import SaveButton from '../../Buttons/SaveButton/SaveButton';
import { useTranslation } from 'react-i18next';
import { disableEscKey } from '../Util';
import { rejectAccordance } from '../../../../api/accordanceApi';
import CloseCrossButton from '../../Buttons/CloseCrossButton/CloseCrossButton';
import BaseModal from '../BaseModal';
import ConfirmDelete from '../ConfirmDelete/ConfirmDelete';

type Props = {
  isOpen: boolean;
  closeModal: any;
  accordanceId: number;
  onRejectHandler: Function;
  onCancelToDetail?: Function;
};

const AccordanceReject = (props: Props) => {
  const { isOpen, closeModal, accordanceId, onRejectHandler, onCancelToDetail } = props;
  const { t } = useTranslation();
  const [justification, setJustification] = React.useState('');
  const [showCloseConfirm, setShowCloseConfirm] = React.useState(false);

  const resetData = () => {
    setJustification('');
    closeModal();
  };

  const submit = async () => {
    try {
      await rejectAccordance(accordanceId, justification);
      onRejectHandler();
      setJustification('');
      closeModal();
    } catch (error) { }
  };

  const openCloseConfirmation = () => {
    setShowCloseConfirm(true);
  };

  const confirmCloseRejectModal = () => {
    setShowCloseConfirm(false);
    resetData();
  };

  const modalContent = (
    <div className="modal-accordance-reject-container">
      <div className="header-section">
        <h3>{t('accordance_rejecting')}</h3>
        <CloseCrossButton handleClick={openCloseConfirmation} />
      </div>
      <div className="textarea-section">
        <div className='justification-content'>
          <span>{t('justification_rejection')}</span>
          <p>({t('efas_pending_states_10')})</p>
        </div>
        <textarea placeholder={t('please_write_motivation_reject_accordance')} value={justification} onChange={e => setJustification(e.target.value)}></textarea>
      </div>
      <div className="button-section mt-3">
        <button className="btn btn-primary-outlined" onClick={() => (onCancelToDetail ? onCancelToDetail() : resetData())}>
          {t('return_message')}
        </button>
        <SaveButton handleClick={submit} disabled={!justification.trim()} customText={t('reject')} />
      </div>
    </div>
  );

  return (
    <>
      <BaseModal
        style={styles}
        isOpen={isOpen}
        className="modal-accordance-reject-content"
        onRequestClose={e => disableEscKey(e, resetData)}
      >
        {modalContent}
      </BaseModal>
      <ConfirmDelete
        isOpen={showCloseConfirm}
        closeModal={confirmCloseRejectModal}
        submit={() => setShowCloseConfirm(false)}
        customTitle={'close_without_saving_question'}
        customMessage={'close_without_saving_description'}
        submitButtonText={'continue_editing'}
        cancelButtonText={'close_without_saving'}
      />
    </>
  );
};

export default AccordanceReject;
